module.exports = __webpack_public_path__ + "static/media/clouds.afd1747f.png";